<template>
  <div>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <i class="icon ion-ios-filing-outline"></i>
        <div class="mg-l-20">
          <h4>{{ $t("router.仓库流水管理") }}</h4>
        </div>
      </div>
      <div class="tx-right">
        <button
          class="btn btn-success"
          v-if="isSysRights('Production.exportInventoryFlow')"
          @click="exportData"
        >
          {{ $t("warehouse.导出数据") }}
        </button>
      </div>
    </div>
    <div
      class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30"
    >
      <div class="clear-key">
        <a
          v-show="keyName"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('keyName')"
        >
          {{ $t("warehouse.仓库名：") }}
          <span class="mg-r-10">{{ keyName }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="batchBool"
          @click="clearKey('batchBool')"
          href="javascript:;"
          class="mg-r-15"
        >
          {{ $t("distributor.批量搜索") }}
          
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="keySkuName"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('keySkuName')"
        >
          {{ $t("warehouse.SKU名称：") }}
          <span class="mg-r-10">{{ keySkuName }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="keySkuCode"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('keySkuCode')"
        >
          {{ $t("product.SKU编号：") }}
          <span class="mg-r-10">{{ keySkuCode }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="keyDateFrom"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('keyDateFrom')"
        >
          {{ $t("financial.起始日期：") }}
          <span class="mg-r-10">{{ keyDateFrom }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="keyDateTo"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('keyDateTo')"
        >
          {{ $t("financial.截止日期：") }}
          <span class="mg-r-10">{{ keyDateTo }}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["keyName", "keySkuName", "keySkuCode", "keyDateFrom", "keyDateTo", "batchBool"],
  methods: {
    clearKey(type) {
      this.$emit("clearKey", type);
    },
    exportData() {
      if ($("#ifile").length == 0) {
        $("body").append('<iframe id="ifile" style="display:none"></iframe>');
      }
      let openDownload = (url) => {
        document.getElementById("ifile").src = url;
      };
      this.$parent.loading = true;
      $.api_call(
        "api.Production.exportInventoryFlow",
        {
          warehouseName: this.keyName,
          skuName: this.keySkuName,
          sku: this.keySkuCode,
          startDate: this.keyDateFrom,
          endDate: this.keyDateTo,
        },
        (r) => {
          this.$parent.loading = false;
          if (r.ErrorCode == "9999") {
            this.$parent.checkArr = [];
            if (r.Data.Results.addTask) {
              this.$store.commit("addTaskTimeFn", moment().unix());
              return;
            }
            openDownload(r.Data.Results);
          } else {
            if (r.ErrorCode == "1002") {
              userFailure(this);
            } else {
              ShowTip(r.Message, "danger");
            }
          }
        }
      );
    },
  },
};
</script>